import {
  ImageCheck,
  LinkWrapper,
  LoadingListEntityProfile,
  PaginationList,
} from "Explore/Components";
import { ImageCheckType } from "Explore/Config/ImageType";
import {
  getAuthorCollaboratorGraphById,
  getAuthorCollaboratorsByID,
} from "Explore/Services/Author";
import { Dropdown, Empty, Segmented, Select, Tag } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./FacultyPeers.module.scss";
import TabListSelect, {
  TAB_OPTION_VALUES,
} from "Explore/Components/TabListSelect";
import useExploreInfo from "Hooks/useExploreInfo";
import useFilterAndPagination from "Hooks/useFilterAndPagination";
import { ParamsFilterKey } from "Config/filterSearchParams";
import D3Graph from "Explore/Components/Graph";
import useAuth from "Hooks/useAuth";
import LoginRequiredSection from "Explore/Components/LoginRequired";
const Peer = ({ peer }) => {
  return (
    <div className={styles["peer"]}>
      <div className={styles["avatar"]}>
        <ImageCheck
          url={peer.photo}
          className={styles["photo"]}
          alt={"avatar"}
          type={ImageCheckType.FACULTY_AVATAR}
        />
      </div>
      <div className={styles["info"]}>
        <LinkWrapper
          component={<p className={styles["name"]}>{peer.name}</p>}
          link={`/explore/faculty/${peer.explore_slug || peer.id}`}
        />
        <LinkWrapper
          component={
            <p className={styles["inst-name"]}>{peer.institution.name}</p>
          }
          link={`/explore/institution/${peer.institution.explore_slug || peer.institution.id}`}
        />
        <p className={styles["position"]}>{peer.position}</p>
        <div className={styles["tags"]}>
          {window.screen.width < 480
            ? peer.keywords.slice(0, 3).map((item, index) => {
                return (
                  <Tag
                    key={index}
                    color="var(--light-blue)"
                    style={{ cursor: "pointer" }}
                  >
                    {item.id}
                  </Tag>
                );
              })
            : peer.keywords.map((item, index) => {
                return (
                  <Tag
                    key={index}
                    color="var(--light-blue)"
                    style={{ cursor: "pointer" }}
                  >
                    {item.id}
                  </Tag>
                );
              })}
        </div>
      </div>
    </div>
  );
};
const FacultyPeers = ({ selectedKeywords, tab, institutionId }) => {
  const { isAuthLoading, userTypeConfig } = useAuth({
    entityType: "FACULTY",
  });
  const { entity_id: faculty_id } = useExploreInfo();
  const { filter } = useFilterAndPagination();
  const [data, setData] = useState({ data: [], isLoading: true });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalRows: 0,
  });
  const [tabOption, setTabOption] = useState(TAB_OPTION_VALUES.LIST);
  const [collaboratorTab, setCollaboratorTab] = useState("all");
  const [showLoginSection, setShowLoginSection] = useState(false);

  useEffect(() => {
    if (tab === "collaborators") {
      setData({ ...data, isLoading: true });
      const _institutionId =
        collaboratorTab === "internal" ? institutionId : null;
      const institutionIdExclude =
        collaboratorTab === "external" ? institutionId : null;

      if (tabOption === TAB_OPTION_VALUES.LIST && !isAuthLoading) {
        getAuthorCollaboratorsByID(
          faculty_id,
          _institutionId,
          institutionIdExclude,
          selectedKeywords,
          pagination.page - 1,
          pagination.rowsPerPage,
          (res) => {
            setData({ data: res.results, isLoading: false });
            if (res.total >= 0) {
              setPagination({
                ...pagination,
                totalRows: res.total,
              });
            }
          },
          (err) => {
            if (err?.response?.status === 401) {
              setShowLoginSection(true);
            }
            setData({ data: [], isLoading: false });
          }
        );
      } else if (tabOption === TAB_OPTION_VALUES.GRAPH) {
        getAuthorCollaboratorGraphById({
          id: faculty_id,
          institutionId: _institutionId,
          institutionIdExclude,
          keywords: selectedKeywords,
          top_k: filter[ParamsFilterKey.TOP_K],
          top_k_edges: filter[ParamsFilterKey.TOP_K_EDGES],
        }).then((res) => {
          setData({ data: res.data, isLoading: false });
        });
      }
    }
  }, [
    faculty_id,
    selectedKeywords,
    pagination.page,
    pagination.rowsPerPage,
    tab,
    collaboratorTab,
    tabOption,
    filter[ParamsFilterKey.TOP_K],
    filter[ParamsFilterKey.TOP_K_EDGES],
    isAuthLoading,
  ]);
  return (
    <div className={styles["faculty-peers"]}>
      <div className={styles["header"]}>
        <TabListSelect currentOption={tabOption} setOption={setTabOption} />
        <div className={styles["filter"]}>
          <div className={styles["mode-select"]}>
            <p>Mode:</p>
            <Select
              style={{ width: 120 }}
              value={collaboratorTab}
              onChange={(value) => setCollaboratorTab(value)}
              options={[
                { value: "internal", label: "Internal" },
                { value: "external", label: "External" },
                { value: "all", label: "All" },
              ]}
            />
          </div>
        </div>
      </div>

      {tabOption === TAB_OPTION_VALUES.LIST && (
        <div>
          <LoadingListEntityProfile
            isLoading={data.isLoading}
            component={
              Array.isArray(data.data) &&
              (data.data.length > 0 ? (
                data?.data.map((item, index) => {
                  return <Peer key={index} peer={item} />;
                })
              ) : showLoginSection ? (
                <LoginRequiredSection />
              ) : (
                <Empty description="No Peer Found." />
              ))
            }
            componentNum={10}
            rows={2}
            avatar={true}
          />
          <PaginationList
            pagination={pagination}
            setPagination={setPagination}
            sizeChanger={userTypeConfig.ui_components.pageSizeChanger}
          />
        </div>
      )}

      {tabOption === TAB_OPTION_VALUES.GRAPH && (
        <div>
          <D3Graph
            data={data.data}
            isLoading={data.isLoading}
            graphType="faculty"
          />
        </div>
      )}
    </div>
  );
};

export default FacultyPeers;
